import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { TeamRecruitmentPipeline } from "@/components/sales/TeamRecruitmentPipeline";
import { TeamProspectFormModal } from "@/components/sales/TeamProspectFormModal";
import { TeamStatsOverview } from "@/components/sales/TeamStatsOverview";
import { TeamOutreachManager } from "@/components/sales/TeamOutreachManager";
import { CoachRelationshipTracker } from "@/components/sales/CoachRelationshipTracker";

const TeamsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState("pipeline");
  const [showProspectForm, setShowProspectForm] = useState(false);

  return (
    <div className="flex flex-col space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Teams & Organizations</h1>
          <p className="text-muted-foreground">
            Manage team recruitment, coach relationships, and event participation
          </p>
        </div>
        <Button onClick={() => setShowProspectForm(true)} className="flex items-center gap-2">
          <Plus className="h-4 w-4" />
          Add Team Prospect
        </Button>
      </div>

      {/* Stats Overview */}
      <TeamStatsOverview />

      {/* Main Content Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="pipeline">Recruitment Pipeline</TabsTrigger>
          <TabsTrigger value="prospects">Team Prospects</TabsTrigger>
          <TabsTrigger value="outreach">Outreach Campaigns</TabsTrigger>
          <TabsTrigger value="coaches">Coach Relations</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>

        <TabsContent value="pipeline" className="space-y-6">
          <TeamRecruitmentPipeline />
        </TabsContent>

        <TabsContent value="prospects" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Team Prospects Management</CardTitle>
              <CardDescription>
                View and manage your team prospects. Use the "Add Team Prospect" button above to add new prospects.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-center py-8 text-muted-foreground">
                Team prospects list view coming soon...
                <br />
                For now, use the Pipeline tab to view prospects and the "Add Team Prospect" button to add new ones.
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="outreach" className="space-y-6">
          <TeamOutreachManager />
        </TabsContent>

        <TabsContent value="coaches" className="space-y-6">
          <CoachRelationshipTracker />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Team Recruitment Analytics</CardTitle>
              <CardDescription>
                Performance metrics and insights for team recruitment efforts
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-center py-8 text-muted-foreground">
                Analytics dashboard coming soon...
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {/* Team Prospect Form Modal */}
      <TeamProspectFormModal
        open={showProspectForm}
        onClose={() => setShowProspectForm(false)}
        onSuccess={() => {
          setShowProspectForm(false);
          // You could refresh data here if needed
        }}
      />
    </div>
  );
};

export default TeamsPage;